import { Component } from '@angular/core';

interface Highlight {
  icon: string;
  title: string;
  desc: string;
}

/**
 * Four factual platform-capability highlights.
 * No fabricated numbers — every claim is what the product actually does.
 */
@Component({
  selector: 'app-stats-bar',
  standalone: true,
  imports: [],
  template: `
    <div
      class="grid grid-cols-2 md:grid-cols-4"
      style="border-top:1px solid var(--theme-border);border-bottom:1px solid var(--theme-border)"
    >
      @for (h of highlights; track h.title; let i = $index) {
        <div
          class="relative flex flex-col items-center justify-center gap-3 py-10 px-6 text-center overflow-hidden reveal"
          [class]="'stagger-' + (i + 1)"
          [style.border-right]="i < highlights.length - 1 ? '1px solid rgba(255,255,255,0.05)' : ''"
        >
          <!-- ambient glow -->
          <div
            class="absolute inset-0 pointer-events-none"
            style="background:radial-gradient(ellipse at 50% 100%, rgba(0,140,240,0.04) 0%, transparent 70%)"
          ></div>

          <!-- Icon badge -->
          <div
            class="relative z-10 w-10 h-10 rounded-xl flex items-center justify-center shrink-0"
            style="background:rgba(0,140,240,0.12);border:1px solid rgba(0,140,240,0.25)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-5 h-5"
              style="color:#008CF0"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
            >
              <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="h.icon"/>
            </svg>
          </div>

          <!-- Text -->
          <div class="relative z-10">
            <div
              class="font-display font-bold text-base leading-tight mb-1"
              style="color:var(--theme-text)"
            >
              {{ h.title }}
            </div>
            <div class="text-xs leading-relaxed" style="color:var(--theme-text-dim)">
              {{ h.desc }}
            </div>
          </div>
        </div>
      }
    </div>
  `,
  styles: [`:host { display: block; }`],
})
export class StatsBarComponent {
  highlights: Highlight[] = [
    {
      icon: 'M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0zM15 11a3 3 0 11-6 0 3 3 0 016 0z',
      title: 'GPS Fleet Tracking',
      desc:  'Real-time location, fuel & maintenance on every vehicle',
    },
    {
      icon: 'M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3',
      title: 'Shipper ↔ Carrier',
      desc:  'Direct marketplace — no middlemen, competitive live bidding',
    },
    {
      icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01',
      title: 'Live Load Timeline',
      desc:  'Every delivery step tracked from pickup to delivery',
    },
    {
      icon: 'M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z',
      title: 'Multi-Currency Pay',
      desc:  'Pre & post-payment, mutual ratings, port clearance support',
    },
  ];
}
